export default "__VITE_ASSET__CCn$XJVC__"